import { Instance } from 'mobx-state-tree';
import { SolutionStatusDtoModelBase } from './SolutionStatusDtoModel.base';

/* The TypeScript type of an instance of SolutionStatusDtoModel */
export interface SolutionStatusDtoModelType extends Instance<typeof SolutionStatusDtoModel.Type> {}

/* A graphql query fragment builders for SolutionStatusDtoModel */
export { selectFromSolutionStatusDto, solutionStatusDtoModelPrimitives, SolutionStatusDtoModelSelector } from './SolutionStatusDtoModel.base';

/**
 * SolutionStatusDtoModel
 */
export const SolutionStatusDtoModel = SolutionStatusDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
